var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5C4.1 1.5 1 4.6 1 8.5C1 12.4 4.1 15.5 8 15.5C11.9 15.5 15 12.4 15 8.5C15 4.6 11.9 1.5 8 1.5ZM8 14.5C4.7 14.5 2 11.8 2 8.5C2 5.2 4.7 2.5 8 2.5C11.3 2.5 14 5.2 14 8.5C14 11.8 11.3 14.5 8 14.5Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 12L8 9.3L5.3 12L4.5 11.2L7.2 8.5L4.5 5.8L5.3 5L8 7.7L10.7 5L11.5 5.8L8.8 8.5L11.5 11.2L10.7 12Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8ca449c46874b1ec2fc6e16c592ff27e.svg";
export { ForwardRef as ReactComponent };